<template>
  <b-form class="onboarding-profile-form form" @submit.prevent="onSubmit">
    <div class="form__section">
      <h3 class="page-subtitle">Complete your details</h3>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.full_name"
              type="text"
              autofocus
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('full_name')"
              placeholder="Full Name"
            ></custom-input>
            <error-message :error="form.$getError('full_name')"></error-message>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.birth_date"
              type="text"
              placeholder="Date of Birth"
              readonly
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('birth_date')"
              @click="showDatepicker(true)"
              @focus="showDatepicker(true)"
              @blur="showDatepicker(false)"
            >
            </custom-input>
            <date-picker
              ref="datepicker"
              v-model="datepickerValue"
              :is-auto-closeable="false"
              :change-month-function="true"
              :change-year-function="true"
              :is-modal="true"
              :new-current-date="datepickerCurrentDate"
              :limits="datepickerBirthLimit"
              :date-format="datepickerFormat"
              @dayClicked="onSelectedDate"
            ></date-picker>
            <error-message
              :error="form.$getError('birth_date')"
            ></error-message>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              type="text"
              v-model="form.phone_number"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('phone_number')"
              placeholder="Phone number"
            ></custom-input>
            <error-message
              :error="form.$getError('phone_number')"
            ></error-message>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.address_1"
              type="text"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('address_1')"
              placeholder="Address Line 1"
            ></custom-input>
            <error-message :error="form.$getError('address_1')"></error-message>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.city"
              type="text"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('city')"
              placeholder="City or Suburb"
            ></custom-input>
            <error-message :error="form.$getError('city')"></error-message>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.postal_code"
              type="number"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('postal_code')"
              placeholder="Postcode"
            ></custom-input>
            <error-message
              :error="form.$getError('postal_code')"
            ></error-message>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.state"
              type="text"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('state')"
              placeholder="State"
            ></custom-input>
            <error-message :error="form.$getError('state')"></error-message>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <custom-input
              v-model="form.country"
              type="text"
              required
              :disabled="form.$busy"
              :is-invalid="form.$getError('country')"
              placeholder="Country"
            ></custom-input>
            <error-message :error="form.$getError('country')"></error-message>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="form__section mb-0">
      <b-button type="submit" block variant="primary" :disabled="form.$busy">
        <b-spinner small v-if="form.$busy"></b-spinner>
        Continue</b-button
      >
    </div>
  </b-form>
</template>
<script>
/**
 * ==================================================================================
 * Onboarding Profile form
 * ==================================================================================
 **/

import { mapActions, mapGetters } from 'vuex'
import Form from '@/utils/form'
import Datepicker from '@/utils/mixins/datepicker'
import ErrorMessage from '@/components/inputs/ErrorMessage.vue'
import CustomInput from '@/components/inputs/CustomInput'

export default {
  components: {
    CustomInput,
    ErrorMessage
  },
  mixins: [Datepicker],
  data: function() {
    return {
      form: new Form({
        full_name: null,
        birth_date: null,
        phone_number: null,
        address_1: null,
        city: null,
        postal_code: null,
        state: null,
        country: null
      })
    }
  },
  methods: {
    ...mapActions({
      updateUser: 'auth/updateUser'
    }),
    ...mapGetters({
      getNeededVerification: 'auth/getNeededVerification'
    }),

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)
      await this.updateUser(this.form.$data())
        .then(() => {
          let route = this.getNeededVerification()
          if (route) {
            this.$router.push(route)
          } else {
            this.$router.push({ name: 'auth.onboarding-id-page' })
          }
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
        })
    },

    onSelectedDate(value) {
      this.showDatepicker(false)
      if (value.date) {
        if (this.isSameOrBefore(value.date, this.datepickerBirthLimit.max)) {
          this.form.birth_date = this.parseDate(value.date)
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.onboarding-profile-form {
}
</style>
